import { TFunction } from 'i18next'

import { getFormattedBalance } from '../../../../elements/BalanceCell/utils/getFormattedBalance'
import { GenericTableRow } from '../../../../utils/buildTableData'
import { BALANCE_COLUMNS } from '../constants/balanceColumns'
import { TrialBalanceTableBalance } from '../types/tableTypes'
import { getBalanceByType } from './getBalanceByType'

export const getHeaderRow = (t: TFunction): string[] => [
  '', // First empty cell for the row
  ...BALANCE_COLUMNS.map((column) => t(column.label)),
]

export const getRowData = (row: GenericTableRow<TrialBalanceTableBalance>): string[] => [
  row.label,
  ...BALANCE_COLUMNS.map((activeColumn) => {
    const balance = getBalanceByType(row.balances, activeColumn.key) || 0

    return getFormattedBalance(balance, false)
  }),
]
